/** Blank biodata payload matching the backend BiodataInput model. */
export const EMPTY_BIODATA = {
  title: "My Biodata",
  template: "classic",
  privacy: "private",
  photo_url: "",
  personal: {
    full_name: "",
    date_of_birth: "",
    time_of_birth: "",
    place_of_birth: "",
    gender: "",
    height: "",
    weight: "",
    complexion: "",
    blood_group: "",
    marital_status: "",
    mother_tongue: "",
    religion: "",
    caste: "",
    sub_caste: "",
    gothra: "",
    manglik: "",
    rashi: "",
    nakshatra: "",
  },
  family: {
    father_name: "",
    father_occupation: "",
    mother_name: "",
    mother_occupation: "",
    siblings: "",
    family_type: "",
    family_status: "",
    family_values: "",
    native_place: "",
  },
  education_career: {
    highest_qualification: "",
    field_of_study: "",
    college: "",
    occupation: "",
    designation: "",
    company: "",
    annual_income: "",
    work_location: "",
  },
  lifestyle: {
    diet: "",
    drinking: "",
    smoking: "",
    hobbies: "",
    languages_known: "",
    about_me: "",
  },
  contact: {
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
  },
  partner_preferences: {
    age_range: "",
    height_range: "",
    education: "",
    occupation: "",
    income: "",
    religion: "",
    caste: "",
    location: "",
    diet: "",
    marital_status: "",
    other: "",
  },
};

export const TEMPLATES = [
  { id: "classic", label: "Classic Traditional" },
  { id: "modern", label: "Modern Minimal" },
  { id: "royal", label: "Royal Ornate" },
];

export const PRIVACY_OPTIONS = [
  { id: "private", label: "Private" },
  { id: "shareable", label: "Shareable Link" },
  { id: "members", label: "Members Only" },
  { id: "public", label: "Public" },
];

export const WIZARD_STEPS = [
  { id: "personal", label: "Personal" },
  { id: "family", label: "Family" },
  { id: "education_career", label: "Education & Career" },
  { id: "lifestyle", label: "Lifestyle" },
  { id: "partner_preferences", label: "Partner Preferences" },
  { id: "contact", label: "Contact" },
];

const GUEST_KEY = "sb.guest.biodata";

export function loadGuestBiodata() {
  try {
    const raw = localStorage.getItem(GUEST_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveGuestBiodata(data) {
  try {
    localStorage.setItem(GUEST_KEY, JSON.stringify(data));
  } catch {
    // swallow — quota etc.
  }
}

export function clearGuestBiodata() {
  try {
    localStorage.removeItem(GUEST_KEY);
  } catch {
    // ignore
  }
}
